import React from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CustomButton from '../../../components/common/custom-button/custom-button.jsx';
import Text from '../../../components/common/custom-text/custom-text.jsx';

import styles from './restart-registration-modal.module.scss';

function RestartRegistrationModal({
  open,
  setOpen,
  logoutAndRedirect,
  testId = 'restart-registration-modal',
}) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleRestart = () => {
    setOpen(false);
    logoutAndRedirect({ redirectUrl: '/register' });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="restart-registration-modal-title"
      aria-describedby="restart-registration-modal-description"
      data-testid={testId}
    >
      <DialogTitle
        id="restart-registration-modal-title"
        sx={{ padding: '20px 20px 8px 20px' }}
      >
        <Text variant="l1" as="h2">
          Restarting Will Erase Your Progress
        </Text>
      </DialogTitle>
      <DialogContent
        id="restart-registration-modal-description"
        sx={{ padding: '0px 20px 24px 20px' }}
      >
        <div className={styles.textContainer}>
          <Text variant="b1" color="#4A4D52">
            Only restart if you entered the wrong email — it's saved and can't
            be reused.
          </Text>
          <Text variant="b1" color="#4A4D52">
            Otherwise, you can leave and come back anytime to finish where you
            left off.
          </Text>
        </div>
      </DialogContent>
      <DialogActions sx={{ padding: '0px 20px 20px 20px' }}>
        <div className={styles.buttonContainer}>
          <CustomButton
            variant="primary"
            onClick={handleRestart}
            fullWidth
            data-testid={`${testId}-restart-button`}
          >
            Yes, restart registration
          </CustomButton>
          <CustomButton
            variant="secondary"
            onClick={handleClose}
            fullWidth
            data-testid={`${testId}-continue-button`}
          >
            Continue my progress
          </CustomButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default RestartRegistrationModal;
